// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import './assets/genesis-arlington-child.css'
import Vue from 'vue'
import App from './App'
import VueGtag from 'vue-gtag'
import router from './router'
import store from './store/store';
import 'vue-material-design-icons/styles.css'
import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'

Vue.use(VueGtag, {
  config: {id: 'G-BSNCGMV709'}
}, router);
Vue.use(Vuetify)

Vue.config.productionTip = false

/* eslint-disable no-new */
const vue = new Vue({
  el: '#app',
  router,
  store,
  template: '<App />',
  components: { App }
});

console.log(vue);



// WEBPACK FOOTER //
// ./src/main.js